export const SHOPIFY_DATA = {
    clear_local_storage: false,
};

export function clear_local_storage() {
    SHOPIFY_DATA.clear_local_storage = true;
}
